module.exports = __webpack_public_path__ + "static/media/sliderimage2.0589132c.jpg";